<template>
  <v-form ref="form" v-model="formFieldsValid" lazy-validation>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12" lg="6" xl="6">
          <v-card class="pt-1 pl-1 pr-1">
            <v-row dense>
              <v-col><component :is="'pMultiselect'" :item="itemTipoDocumento" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
              <v-col><v-text-field :label="locDocumento.codice ? 'Numero documento' : 'Numero documento (auto)'" hide-details outlined dense disabled :value="codice"></v-text-field></v-col>
              <v-col><component :is="'pData'" :item="itemData" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
            <v-row dense v-show="magazzinoVisibile">
              <v-col lg="6"><component :is="'pMultiselect'" v-if="magazzinoVisibile" :item="itemMagazzino" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
            <v-row dense v-show="destinazioneMerceVisibile">
              <v-col lg="6"><component :is="'pMultiselect'" v-if="destinazioneMerceVisibile" :item="itemDestinazioneMerce" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
            </v-row>            
            <v-row dense v-if="infoDdtVisibile">
              <v-col><component :is="'pTesto'" :item="itemNumeroBolla" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="ddtChiuso" :updateTrigger="updateTrigger" :textClass="documentoEsistente ? 'orange lighten-1' : ''"/></v-col>
              <v-col><component :is="'pData'" :item="itemDataBolla" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="ddtChiuso" :updateTrigger="updateTrigger"/></v-col>
              <v-col><component :is="'pTesto'" :item="itemRiferimentoBolla" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="ddtChiuso" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
            <v-row dense>
              <v-col><importa-da-parcheggio v-show="mostraParcheggio" :show="mostraParcheggio"/></v-col>
            </v-row>
<!--             <v-row dense v-if="locDocumento.appoggio && locDocumento.appoggio.pagamentoVisibile">
              <v-col><component :is="'pMultiselect'" :item="itemPagamentoModalita" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
              <v-col><component :is="'pMultiselect'" :item="itemPagamentoCondizioni" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
            </v-row> -->
          </v-card> 
        </v-col>
        <v-col cols="12" lg="6" xl="6">
          <v-card class="pt-1 pl-1 pr-1">
            <v-row dense>
              <v-col v-if="locDocumento.appoggio && locDocumento.appoggio.clienteVisibile"><component :is="'pClifor'" :item="itemCliente" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
              <v-col v-if="locDocumento.appoggio && locDocumento.appoggio.fornitoreVisibile"><component :is="'pClifor'" :item="itemFornitore" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
<!--             <v-row dense v-if="locDocumento.appoggio && locDocumento.appoggio.spedizioneVisibile">
              <v-col><component :is="'pDestinazioni'" :item="itemDestinazione" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
            </v-row> -->
            <v-row dense v-if="locDocumento.appoggio && (locDocumento.appoggio.clienteVisibile || locDocumento.appoggio.fornitoreVisibile)">
              <v-col><component :is="'pTesto'" :item="itemCodiceFiscale" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
              <v-col><component :is="'pTesto'" :item="itemPartitaIva" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
<!--               <v-col><component :is="'pTesto'" :item="itemCodiceSdi" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col> -->
            </v-row>             
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import documenti from '@/services/documentiService.js'
import clienti from '@/services/clientiService.js'
import pMultiselect from './elementi/multiselect'
import pData from './elementi/data'
import pClifor from './elementi/clifor'
// import pDestinazioni from './elementi/destinazioni'
import pTesto from './elementi/testo'
import ImportaDaParcheggio from './importaDaParcheggio'

export default {
  components: {
    pMultiselect,
    pData,
    pClifor,
    // pDestinazioni,
    pTesto,
    ImportaDaParcheggio
  },
  props: {
    locDocumento: Object,
    trigger: Number,
    filtraTipiDocumento: Array,
    mostraParcheggio: Boolean,
    forzaTipo: Object
    // tipo: Object
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto,
    updateTrigger: 1,
    documentoEsistente: false
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
  },
  watch: {
    async forzaTipo(tipo) {
      const data = {
        model: 'tipoDocumento.codice',
        subModel: 'codice',        
        value: tipo
      }
      await this.componentValueChange(data)
    },
    async locDocumento(value) {
      this.documentoEsistente = false
    },
    trigger() {

    }
  },
  computed: {
    documentoItems() {
      if (!this.locDocumento || !this.backoffice || !this.updateTrigger) {
        return []
      }
      const vars = this.backoffice.documenti
      const items = []
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        // items.push({value: dot.pick(item.valueField, this.locDocumento, ''), ...item})
        items.push({value: _.get(this, `locDocumento.${item.valueField}`, ''), ...item})
      }
      // console.log(items)
      return items
    },
    codice() {
      return this.trigger && this.locDocumento && this.locDocumento.codice
    },
    cliente() {
      return _.get(this.locDocumento, 'anagrafica.cliente')
    },
    pagamentoVisibile() {
      return this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.pagamentoVisibile
    },
    clienteVisibile() {
      return this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.clienteVisibile
    },
    fornitoreVisibile() {
      return this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.fornitoreVisibile
    },
    spedizioneVisibile() {
      return this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.spedizioneVisibile
    },
    magazzinoVisibile() {
      return this.trigger && this.locDocumento && this.locDocumento.tipoDocumento && ['fatturaImmediata', 'ddt', 'ddtFornitore'].includes(this.locDocumento.tipoDocumento.codice)
    },
    destinazioneMerceVisibile() {
      return true
      // return this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.destinazioneVisibile
    },
    infoDdtVisibile() {
      return this.trigger && this.locDocumento && this.locDocumento.tipoDocumento && ['ddtFornitore'].includes(this.locDocumento.tipoDocumento.codice)
    },
    sede() {
      const destinazione = _.get(this.locDocumento, 'spedizione.destinazione', null)
      if (destinazione) {
        return destinazione
      } else {
        return this.cliente.recapiti.length > 0 ? this.cliente.recapiti[0] : {} 
      }
    },
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza documento'
      } else {
        return this.locDocumento && this.locDocumento._id ? 'Modifica documento' : 'Nuovo documento'
      }
    },
    drawerSubtitle() {
      return this.updateTrigger ? _.get(this.locDocumento, 'tipoDocumento.descrizione', '') : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    ddtChiuso() {
      return this.locDocumento && this.locDocumento.stato && this.locDocumento.stato.codice === 'chiuso'
    },
    nuovoArticoloCreato() {
      var na = this.$store.getters['documenti/articoloCreato'] || null
      return na
    },
    nuovoCliforCreato() {
      var na = this.$store.getters['clienti/cliforCreato'] || null
      return na
    },
    readOnlySeModifica() {
      return _.get(this, 'locDocumento.codice', '') !== ''
    },
    itemTipoDocumento() {
      return {
        "model": "tipoDocumento.codice",
        "subModel": "codice",
        "valueField": "tipoDocumento.codice",
        "type": "Multiselect",
        "label": "Tipo documento",
        "readonly": true,
       //  "source": "documenti_parametri.tipiDocumento",
        "source": this.filtraTipiDocumento && this.filtraTipiDocumento.length > 0 ? this.filtraTipiDocumento : "documenti_parametri.tipiDocumento",
        "required": true,
        "addForbidden": true,
        value: this.trigger && _.get(this.locDocumento, 'tipoDocumento.codice', '')
      }
    },
    itemData() {
      return  {
        "model": "data",
        "valueField": "data",
        "label": "Data",
        "type": "Data",
        "required": true,
        value: _.get(this.locDocumento, 'data', '')
      }
    },
    itemMagazzino() {
      return {
        "model": "magazzino",
        "subModel": "codice",
        "valueField": "magazzino",
        "type": "Multiselect",
        "label": "Magazzino movimento",
        "source": "magazzino_magazzini.magazzini",
        "required": true,
        "addForbidden": true,
        value: _.get(this.locDocumento, 'magazzino', '')
      }
    },
    itemDestinazioneMerce() {
      return {
        "model": "spedizione.destinazione",
        "subModel": "codice",
        "valueField": "spedizione.destinazione",
        "type": "Multiselect",
        "label": "Destinazione merce",
        "source": "spedizioni.destinazioniMerce",
        "required": false,
        "addForbidden": true,
        value: _.get(this.locDocumento, 'spedizione.destinazione', '')
      }
    },    
    itemCliente() {
      return {
        "model": "anagrafica.cliente",
        "valueField": "anagrafica.cliente",
        "label": "Cliente",
        "type": "Clifor",
        "required": false,
        // "showIf": "appoggio.clienteVisibile",
        "note": "tipo Cliente + solo se causale con mostra cliente",
        value: _.get(this.locDocumento, 'anagrafica.cliente', '')
      }
    },
    itemFornitore() {
      return {
        "model": "anagrafica.fornitore",
        "valueField": "anagrafica.fornitore",
        "label": "Fornitore",
        "type": "Clifor",
        "required": false,
        // "showIf": "appoggio.fornitoreVisibile",
        "note": "tipo Fornitore + solo se causale con mostra fornitore",
        value: this.trigger && _.get(this.locDocumento, 'anagrafica.fornitore', '')
      }
    },
    itemDestinazione() {
      return {
        "model": "spedizione.destinazione",
        "subModel": "codice",
        "valueField": "spedizione.destinazione",
        "note": "prende i recapiti del cliente (attenzione, required in alternativa a indirizzo temporaneo)",
        "type": "Destinazioni",
        "label": "Destinazione",
        "source": "destinatario",
        "required": false,
        "addForbidden": false,
        // "showIf": "appoggio.spedizioneVisibile",
        value: _.get(this.locDocumento, 'spedizione.destinazione', '')
      }
    },
    itemCodiceFiscale() {
      return {
        "model": "appoggio.clifor.amministrativi.codiceFiscale",
        "valueField": "appoggio.clifor.amministrativi.codiceFiscale",
        "label": "Codice Fiscale",
        "type": "Testo",
        "readonly": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'appoggio.clifor.amministrativi.codiceFiscale', '')
      }
    },
    itemPartitaIva() {
      return {
        "model": "appoggio.clifor.amministrativi.partitaIva",
        "valueField": "appoggio.clifor.amministrativi.partitaIva",
        "label": "Partita Iva",
        "type": "Testo",
        "readonly": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'appoggio.clifor.amministrativi.partitaIva', '')
      }
    },
    itemCodiceSdi() {
      return {
        "model": "appoggio.clifor.fatturazione.codiceSdi",
        "valueField": "appoggio.clifor.fatturazione.codiceSdi",
        "label": "Codice Sdi",
        "type": "Testo",
        "readonly": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'appoggio.clifor.fatturazione.codiceSdi', '')
      }            
    },
    itemPagamentoCondizioni() {
      return {
        "note": "a rate, completo, anticipo",
        "model": "pagamento.condizioni",
        "subModel": "codice",
        "valueField": "pagamento.condizioni",
        "type": "Multiselect",
        "label": "Condizioni pagamento",
        "source": "documenti_pagamento.condizioniPagamento",
        "required": true,
        "addForbidden": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'pagamento.condizioni', '')
      }
    },
    itemPagamentoModalita() {
      return {
        "model": "pagamento.dettaglio.modalita",
        "subModel": "codice",
        "valueField": "pagamento.dettaglio.modalita",
        "type": "Multiselect",
        "label": "Modalità pagamento",
        "source": "documenti_pagamento.modalitaPagamento",
        "required": true,
        "addForbidden": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'pagamento.dettaglio.modalita', '')        
      }
    },
    itemNumeroBolla() {
      return {
        "model": "info.numeroDocumento",
        "valueField": "info.numeroDocumento",
        "label": "Numero documento fornitore",
        "type": "Testo",
        "update": this.updateTrigger,
        value: _.get(this.locDocumento, 'info.numeroDocumento', '')
      }            
    },
    itemDataBolla() {
      return {
        "model": "info.dataDocumento",
        "valueField": "info.dataDocumento",
        "label": "Data documento fornitore",
        "type": "Data",
        "required": true,
        value: _.get(this.locDocumento, 'info.dataDocumento', new Date())
      }            
    },
    itemRiferimentoBolla() {
      return {
        "model": "info.noteDocumento",
        "valueField": "info.noteDocumento",
        "label": "Note",
        "type": "Testo",
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'info.noteDocumento', '')
      }            
    }
  },
  methods: {
    datiCompleti() {
      const valid = this.$refs.form.validate()
      return valid // TODO: Completare verifica
    },    
    items(idx) {
      const ret = this.documentoItems && this.documentoItems.length >= idx ? this.documentoItems[idx] : {}
      console.log('ret', ret)
      return ret
    },
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value ? value[subModel] : ''
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.locDocumento, tgt)
      await this.aggiornaCorrelati(data)
      this.$emit('aggiornaDocumento', this.locDocumento)
      // this.$store.commit('documenti/SET_DOCUMENTO', this.locDocumento) // verificare se va fatta store_temp
    },
    async aggiornaCorrelati(data) {
      // this.locDocumento.appoggio = this.locDocumento.appoggio || {}
      switch (data.model) {
         case 'tipoDocumento.codice':
          let payload = null
          try {
            payload = _.omit(this.locDocumento.appoggio.tipoDocumento, Object.keys(data.value))
          } catch {}
          this.locDocumento.appoggio.tipoDocumento = data.value
          this.locDocumento.appoggio.clienteVisibile = _.get(data.value, 'visualizzaCliente', false)
          this.locDocumento.appoggio.fornitoreVisibile = _.get(data.value, 'visualizzaFornitore', false)
          this.locDocumento.appoggio.spedizioneVisibile = _.get(data.value, 'infoSpedizione', false)
          this.locDocumento.appoggio.pagamentoVisibile = _.get(data.value, 'infoPagamento', false)
          this.locDocumento.tipoDocumento = data.value
          if (payload) {
            this.locDocumento.appoggio.tipoDocumento = {...this.locDocumento.appoggio.tipoDocumento, ...payload}
            this.locDocumento.tipoDocumento = {...this.locDocumento.tipoDocumento, ...payload}
          }
          // this.locDocumento.tipoDocumentoDescrizione = data.value.descrizione
          this.updateTrigger++
          break;
        case 'anagrafica.cliente':
        case 'anagrafica.fornitore':
          const clienteId = data.value.codice
          const clifor = await clienti.getCliente(clienteId)
          // this.locDocumento.appoggio.clifor = clifor
          _.set(this.locDocumento,'appoggio.clifor', clifor)
          _.set(this.locDocumento, 'pagamento.condizioni', _.get(clifor, 'amministrativi.pagamento.condizioni', ''))
          _.set(this.locDocumento, 'pagamento.dettaglio.modalita', _.get(clifor, 'amministrativi.pagamento.dettaglio.modalita', ''))

          if (!_.get(this.locDocumento, 'spedizione.destinazione')) {
            const sede = clifor.recapiti.length > 0 ? clifor.recapiti.find(x => x.tipo.codice === 'principale') : {}
            _.set(this.locDocumento, 'spedizione.destinazione', sede)
           }          
/*           const sede = clifor.recapiti.length > 0 ? clifor.recapiti.find(x => x.tipo.codice === 'principale') : {}
          _.set(this.locDocumento, 'spedizione.destinazione', sede) */
          _.set(this.locDocumento, data.model + '.amministrativi', _.get(clifor, 'amministrativi', ''))
          _.set(this.locDocumento, data.model + '.fatturazione', _.get(clifor, 'fatturazione', ''))         
          this.updateTrigger++
          break;
        case 'spedizione.destinazione':
          _.set(this.locDocumento, 'spedizione.destinazione', data.value)
          break;
        case 'info.numeroDocumento':
          // Verificare se il documento è già stato inserito. Non bloccante
          const filtri = {
            info: {
              numeroDocumento: data.value
            }
          }
          const elenco = await documenti.getCustomDocumentHeaders(filtri, {})
          const testDoc = elenco.rows.filter(x => x.anagrafica.fornitore.codice === _.get(this.locDocumento, 'anagrafica.fornitore.codice'))
          let esiste = testDoc.length > 0
          if (testDoc.length === 1 && testDoc[0]._id === this.locDocumento._id) {
            esiste = false
          }
          this.documentoEsistente = esiste
          break;
/*         case 'data':
          this.locDocumento.data =  new Date(data.value)
          break; */
        default:
          this.updateTrigger++
          break
      } 
    },
    modificaPrezzoAcquisto(unitario) {
      console.log('Modifica prezzo acquisto')
      if (unitario) {

      } else {

      }
    },
    modificaPrezzoVendita(unitario) {
      console.log('Modifica prezzo vendita')
      if (unitario) {

      } else {
        
      }
    },
    onAnnulla() {
      this.$refs.form.reset()
      this.$store.commit('SET_RIGHT_DRAWER', false)
      this.$store.commit('documenti/SET_REFRESH')
      this.$store.commit('documenti/CLEAR_DOCUMENTO')
    },
    onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        // TODO: eliminare i campi di appoggio creati per la gestione dell'interfaccia
        this.$store.commit('documenti/SET_DOCUMENTO', this.locDocumento)
        this.$store.commit('documenti/SET_DOCUMENTO_SAVED')
      }
    }
  }
}
</script>
